'use client'

import { useQuery } from '@tanstack/react-query'

import type { Campaign } from '../types/campaign'
import { CAMPAIGN_PAGE_VARIANT } from '../lib/campaign-ui'

import { useModalContext } from '@/shared/contexts/Modal'
import { Button } from '@/shared/ui/Button'
import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'
import { NotFoundAlert } from '@/shared/ui/NotFoundAlert'
import { Page } from '@/shared/ui/Page'

import { CampaignJoinByCodeModal } from './CampaignJoinByCodeModal'
import { CampaignListItem } from './CampaignListItem'
import { CampaignListSkeleton } from './CampaignListSkeleton'

export function CampaignsListPage() {
  // No custom queryFn — relies on QueryProvider's defaultQueryFn (raw `{ records }`
  // envelope) so this query key matches GlobalPrefetch's eager Shell-mount prefetch
  // byte-for-byte and the two dedupe instead of racing with different shapes.
  const { data, isLoading } = useQuery<{ records: Campaign[] }>({
    queryKey: ['/user/campaigns']
  })
  const campaigns = data?.records ?? []
  const { openModal } = useModalContext()

  return (
    <Page variant={CAMPAIGN_PAGE_VARIANT}>
      <div className="flex w-full min-w-0 max-w-full flex-col items-center gap-4 px-2 sm:px-0">
        <Card
          variant={CAMPAIGN_PAGE_VARIANT}
          showTrophies
          className="w-full max-w-2xl"
        >
          <CardHeader>
            <CardTitle>Campanhas</CardTitle>
          </CardHeader>
          <CardBody>
            <p className="text-center text-sm font-medium text-[#7F7FAD]">
              Competições especiais com ranking próprio. Complete os desafios e
              suba de posição!
            </p>

            <Button
              variant="outline"
              className="mx-auto"
              onClick={() => openModal({ modal: CampaignJoinByCodeModal })}
            >
              Entrar com código
            </Button>

            {isLoading ? (
              <CampaignListSkeleton />
            ) : campaigns.length === 0 ? (
              <NotFoundAlert
                title="Nenhuma campanha ainda"
                text="Quando você entrar em uma campanha pelo link do professor, ela aparecerá aqui."
              />
            ) : (
              <ul className="flex flex-col gap-2">
                {campaigns.map(campaign => (
                  <li key={campaign.id}>
                    <CampaignListItem campaign={campaign} />
                  </li>
                ))}
              </ul>
            )}
          </CardBody>
        </Card>
      </div>
    </Page>
  )
}
